import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {UserFilterRecipients} from '../models/userInUserfilter.model';
import {UserFilter} from '../models/user-filter.model';

@Injectable({
  providedIn: 'root',
})
export class UserFilterService {
  readonly api = environment.api;

  constructor(private http: HttpClient) { }

  getUsersUserFilters(workspaceId: string, userId: string, searchKey: string, pageNumber: number,
                      pageSize: number, needCount: boolean): Observable<any> {
    const bodyRequest = {
      workspaceId,
      userId,
      searchKey,
      pageNumber,
      pageSize,
      needCount,
    };
    return this.http.post(`${this.api}/UserFilter/GetUsersUserFilters`, bodyRequest);
  }

  getUserGroupsUserFilters(workspaceId: string, userGroupId: string, searchKey: string, pageNumber: number,
                      pageSize: number, needCount: boolean): Observable<any> {
    const bodyRequest = {
      workspaceId,
      userGroupId,
      searchKey,
      pageNumber,
      pageSize,
      needCount,
    };
    return this.http.post(`${this.api}/UserFilter/GetUserGroupsUserFilters`, bodyRequest);
  }

  getDataSourceUserFilters(workspaceId: string, dataSourceId: string, searchKey: string, pageNumber: number,
                           pageSize: number, needCount: boolean): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
      searchKey,
      pageNumber,
      pageSize,
      needCount,
    };

    return this.http.post(`${this.api}/UserFilter/GetDataSourceUserFilters`, bodyRequest);
  }

  getDashboardUserFilters(workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/UserFilter/GetDashboardUserFilters`,bodyRequest);
  }

  getChartUserFilters(workspaceId: string, dashboardId: string, chartId: string): Observable<any> {
    const bodyRequest = {
      chartId,
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/UserFilter/GetChartUserFilters`,bodyRequest);
  }

  getUserAndGroupToAddUserFilter(userFilterId: string, workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      userFilterId,
      workspaceId,
      dataSourceId,
    };
    return this.http.post(`${this.api}/UserFilter/GetSoloAndGroupToAddUserFilter`, bodyRequest);
  }

  getUserFiltersToAddDashboard(workspaceId: string, dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/UserFilter/GetUserFiltersToAddDashboard`,bodyRequest);
  }

  getUserFiltersToAddChart(workspaceId: string, dashboardId: string, chartId): Observable<any> {
    const bodyRequest = {
      chartId,
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/UserFilter/GetUserFiltersToAddChart`,bodyRequest);
  }

  getColumnValues(columnId: string, selectedValues: string[], paginationValues: any,
                  workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      columnId,
      selectedValues,
      paginationValues,
      workspaceId,
      dataSourceId,
    };
    return this.http.post(`${this.api}/UserFilter/GetColumnValues`, bodyRequest);
  }

  removeUserFilter(userFilter: Partial<UserFilter>): Observable<any> {
    const bodyRequest = {
      userFilterId: userFilter.userFilterId,
      workspaceId: userFilter.workspaceId,
      dataSourceId: userFilter.dataSourceId,
    };
    return this.http.post(`${this.api}/UserFilter/RemoveUserFilter`, bodyRequest);
  }

  createUseFilter(columnId: string, name: string, userFilterRecipients: Partial<UserFilterRecipients>[],
                  workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      columnId,
      name,
      userFilterRecipients,
      workspaceId,
      dataSourceId,
    };
    return this.http.post(`${this.api}/UserFilter/CreateUserFilter`, bodyRequest);
  }

  updateUseFilter(userFilterId: string, columnId: string, name: string,
                  userFilterRecipients: Partial<UserFilterRecipients>[],
                  workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      userFilterId,
      columnId,
      name,
      userFilterRecipients,
      workspaceId,
      dataSourceId,
    };
    return this.http.post(`${this.api}/UserFilter/UpdateUserFilter`, bodyRequest);
  }

  getDataSourceUserFilterDetails(userFilter: Partial<UserFilter>): Observable<any> {
    const bodyRequest = {
      userFilterId: userFilter.userFilterId,
      workspaceId: userFilter.workspaceId,
      dataSourceId: userFilter.dataSourceId,
    };
    return this.http.post(`${this.api}/UserFilter/GetDataSourceUserFilterDetails`, bodyRequest);
  }

  getDashboardUserFilterDetails(workspaceId: string, dashboardId: string, userFilterId: string): Observable<any> {
    const bodyRequest = {
      userFilterId,
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/UserFilter/GetDashboardUserFilterDetails`, bodyRequest);
  }

  getChartUserFilterDetails(workspaceId: string, dashboardId: string,
                            userFilterId: string, chartId: string): Observable<any> {
    const bodyRequest = {
      chartId,
      userFilterId,
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/UserFilter/GetChartUserFilterDetails`, bodyRequest);
  }

  addUserFilterToDashboard(workspaceId: string, dashboardId: string, userFilterId: string): Observable<any> {
    const bodyRequest = {
      userFilterId,
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/UserFilter/AddUserFilterToDashboard`, bodyRequest);
  }

  addUserFilterToChart(workspaceId: string, dashboardId: string, userFilterId: string, chartId: string): Observable<any> {
    const bodyRequest = {
      chartId,
      userFilterId,
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/UserFilter/AddUserFilterToChart`, bodyRequest);
  }

  removeUserFilterFromDashboard(workspaceId: string, dashboardId: string, userFilterId: string): Observable<any> {
    const bodyRequest = {
      userFilterId,
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/UserFilter/RemoveUserFilterFromDashboard`, bodyRequest);
  }

  removeUserFilterFromChart(workspaceId: string, dashboardId: string,
                            userFilterId: string, chartId: string): Observable<any> {
    const bodyRequest = {
      chartId,
      userFilterId,
      workspaceId,
      dashboardId,
    };
    return this.http.post(`${this.api}/UserFilter/RemoveUserFilterFromChart`, bodyRequest);
  }
}
